import React from 'react';
import { useUser } from '@clerk/react';
import { Link } from 'react-router-dom';
import { isSuperadminEmail } from '../auth/superadminEmails';

const DEV_BYPASS_AUTH = (import.meta as ImportMeta & { env?: Record<string, string> }).env?.VITE_DEV_BYPASS_AUTH === '1';

/**
 * Blocking modal shown to superadmin users who have NOT enabled MFA.
 * Per D-05: MFA is opt-in for everyone, ENFORCED for superadmins.
 *
 * Render once inside the authenticated app shell (App.tsx, after isSignedIn guard).
 * Returns null for all non-superadmin users and superadmins who already have MFA on.
 */
export default function TaskSetupMFA(): React.ReactElement | null {
  if (DEV_BYPASS_AUTH) return null;

  const { user, isLoaded } = useUser();
  if (!isLoaded || !user) return null;

  const primary = user.primaryEmailAddress?.emailAddress?.toLowerCase();
  if (!isSuperadminEmail(primary)) return null;

  if (user.twoFactorEnabled) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="task-mfa-title"
      data-testid="task-setup-mfa"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.55)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '2.5rem',
          maxWidth: '420px',
          width: '90%',
          boxShadow: '0 24px 64px rgba(0,0,0,0.18)',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: '#F16E00',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1.25rem',
            fontSize: '1.5rem',
          }}
          aria-hidden="true"
        >
          🔐
        </div>
        <h2
          id="task-mfa-title"
          style={{ fontWeight: 700, fontSize: '1.2rem', marginBottom: '0.75rem' }}
        >
          Stel tweestapsverificatie in
        </h2>
        <p style={{ color: '#555', fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '1.75rem' }}>
          Dit account heeft superadmin-rechten. Je moet tweestapsverificatie
          inschakelen voordat je verder kunt.
        </p>
        <Link
          to="/account/security"
          style={{
            display: 'inline-block',
            background: '#F16E00',
            color: '#fff',
            fontWeight: 700,
            padding: '0.75rem 2rem',
            borderRadius: '8px',
            textDecoration: 'none',
            fontSize: '0.9rem',
            letterSpacing: '0.02em',
          }}
        >
          Nu instellen →
        </Link>
      </div>
    </div>
  );
}
